import styled from '@emotion/styled';
import MuiBox from '@mui/material/Box';

export const Box = styled(MuiBox)`
  height: fit-content;
  overflow: scroll;
`;
